var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 27.351C19.6274 27.351 25 22.0451 25 15.5C25 11.5605 23.0536 8.07005 20.0588 5.91522M14.4118 30L11.5882 27.2115L14.4118 24.4231M13 3.64904C6.37258 3.64904 1 8.95489 1 15.5C1 19.4395 2.94635 22.93 5.94118 25.0848M11.5882 6.57692L14.4118 3.78846L11.5882 1",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.3e3f08fde07369179364836f14751442.svg";
export { ForwardRef as ReactComponent };